import { getActiveProject } from '../CommonComponents/ProjectConfig';

const Home = () => {
    const activeProject = getActiveProject();
    return (
        <>
            <div className="h-[90vh] flex items-center justify-center relative overflow-hidden bg-[#f4f8fb]">
                <div className="absolute w-72 h-72 rounded-full bottom-10 left-10 opacity-20 blur-2xl" style={{ backgroundColor: activeProject.theme.primary }}></div>
                <div className="absolute w-72 h-72 rounded-full top-10 right-10 opacity-20 blur-2xl" style={{ backgroundColor: activeProject.theme.primary }}></div>
                <div className="p-10 w-[800px] text-center bg-white rounded-2xl shadow-lg border" style={{ borderColor: `${activeProject.theme.primary}33` }}>
                    <div className="flex justify-center mb-4">
                        <img
                            src={activeProject.logo}
                            alt={`${activeProject.name} Logo`}
                            style={{ height: "150px", objectFit: "contain" }}
                        />
                    </div>
                    <p className="text-sm text-gray-600 mb-8">
                        Track, manage, and optimize your logistics operations with ease.
                    </p>
                </div>
            </div>
        </>
    );
}

export default Home;